import { newsApi } from './api';


export const DashboardService = newsApi.injectEndpoints({
    endpoints: (build) => ({
        getDashboard: build.query({
            query: () => ({
                url: `dashboard`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        getGraph: build.query({
            query: () => ({
                url: `dashboard/statistics`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetDashboardQuery,
    useGetGraphQuery,
} = DashboardService